import React from 'react';
import { Skeleton } from '..';
require("./Skeleton-VerticalCard.css");
var styles = {
  "Root": "Skeleton-VerticalCard-module-Root_1f0",
  "Img": "Skeleton-VerticalCard-module-Img_275",
  "Wrapper": "Skeleton-VerticalCard-module-Wrapper_2Ny",
  "Btn": "Skeleton-VerticalCard-module-Btn_rrs"
};
export const SkeletonVerticalCard = () => /*#__PURE__*/React.createElement("div", {
  className: styles.Root
}, /*#__PURE__*/React.createElement(Skeleton, {
  width: "152px",
  height: "152px",
  borderRadius: "4px",
  className: styles.Img
}), /*#__PURE__*/React.createElement("div", {
  className: styles.Wrapper
}, /*#__PURE__*/React.createElement(Skeleton, {
  width: "152px",
  height: "14px",
  borderRadius: "4px"
}), /*#__PURE__*/React.createElement(Skeleton, {
  width: "122px",
  height: "14px",
  borderRadius: "4px"
})), /*#__PURE__*/React.createElement(Skeleton, {
  width: "107px",
  height: "32px",
  borderRadius: "29px",
  className: styles.Btn
}));